// src/pages/DirectPage/DirectPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { auth, db } from '../../services/firebase';
import { doc, getDoc, updateDoc, arrayUnion } from 'firebase/firestore';
import { getUserById } from '../../utils/userUtils';
import { directPageStyles } from './styles';
import { useMessaging } from './useMessaging';
import ChatHeader from './ChatHeader';
import MessagesList from './MessagesList';
import MessageInput from './MessageInput';

// Spinner Icon SVG
const SpinnerIcon = () => (
  <svg 
    width="48" 
    height="48" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2"
    style={{
      animation: 'spin 1s linear infinite'
    }}
  >
    <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" />
  </svg>
);

const DirectPage = () => {
  const { threadId } = useParams();
  const user = auth.currentUser;
  const [currentUser, setCurrentUser] = useState(null);
  
  const {
    directs,
    seller,
    text,
    setText,
    handleSend,
    loading
  } = useMessaging(threadId, user);

  // Fetch current user's profile
  useEffect(() => {
    const fetchCurrentUser = async () => {
      if (user?.uid) {
        const userData = await getUserById(user.uid);
        setCurrentUser(userData);
      }
    };
    fetchCurrentUser();
  }, [user]);

  // Mark this direct thread as read when user visits
  useEffect(() => {
    if (!user || !threadId) return;

    const markThreadAsRead = async () => {
      try {
        // Update localStorage to track this specific thread visit
        localStorage.setItem(`lastDirectVisit_${user.uid}_${threadId}`, new Date().toISOString());
        
        // Mark the thread as read in Firestore
        const threadRef = doc(db, 'messages', threadId);
        const threadSnap = await getDoc(threadRef);
        
        if (threadSnap.exists()) {
          const data = threadSnap.data();
          // Only update if current user hasn't read it yet
          if (!data.readBy || !data.readBy.includes(user.uid)) {
            await updateDoc(threadRef, {
              readBy: arrayUnion(user.uid)
            });
            }
        }
      } catch (error) {
        }
    };

    markThreadAsRead();
  }, [user, threadId]);

  // Show loading spinner while fetching user data
  if (loading) {
    return (
      <div style={directPageStyles.pageContainer}>
        <div style={directPageStyles.container}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            gap: '16px'
          }}>
            <SpinnerIcon />
            <p style={{
              color: '#666',
              fontSize: '16px',
              margin: 0
            }}>
              Loading conversation...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={directPageStyles.pageContainer}>
      <div style={directPageStyles.container}>
        <ChatHeader seller={seller} />
        
        <div style={directPageStyles.chatWindow}>
          <MessagesList 
            directs={directs} 
            currentUserId={user?.uid} 
            seller={seller}
            currentUser={currentUser}
          />
          
          <MessageInput 
            text={text}
            setText={setText}
            onSend={handleSend}
            seller={seller}
            currentUserId={user?.uid}
          />
        </div>
      </div>
    </div>
  );
};

export default DirectPage;